import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import { withStyles, MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { withRoomContext } from '../../../RoomContext';
import { connect } from 'react-redux';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Badge from '@material-ui/core/Badge';
import Chat from '../../MeetingDrawer/Chat/Chat';
import Memo from './Memo';
import Icons from '../Common/Icons';

const styles = () =>
	({
		root :
		{
			flexGrow        : 1,
			maxWidth        : 500,
			width           : '100%',
			height          : '100%',
			borderRadius    : '0.5rem',
			boxShadow       : 'none',
			backgroundColor : 'transparent',
			paddingRight    : '1%'
		},
		tabBody : {
			backgroundColor         : 'white',
			height                  : 'calc(100% - 4rem)',
			borderBottomRightRadius : '0.5rem',
			borderBottomLeftRadius  : '0.5rem',
			borderTopRightRadius    : '0.5rem',
			boxShadow               : '2px 2px 4px #aaa'
		},
		memo :
		{
			height  : '100%',
			padding : '2%'
		}
	});

function TabPanel(props)
{
	const {
		children,
		value,
		index,
		classes,
		...other
	} = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			className={classes.tabBody}
			{...other}
		>
			{value === index && (
				children
			)}
		</div>
	);
}

TabPanel.propTypes =
{
	classes  : PropTypes.any.isRequired,
	children : PropTypes.node,
	index    : PropTypes.any.isRequired,
	value    : PropTypes.any.isRequired
};

const theme = createTheme({
	overrides : {
		MuiTabs : {
			root : {
				height    : '4rem',
				minHeight : 0
			},
			indicator : {
				backgroundColor : 'transparent',
				color           : '#9ec317',
				width           : '0'
			}
		},
		MuiTab : {
			root : {
				minWidth             : 80,
				borderTopRightRadius : '0.5rem',
				borderTopLeftRadius  : '0.5rem',
				'&:hover'            : {
					backgroundColor : 'transparent',
					color           : '#9ec317'
				},
				'&$selected' : {
					backgroundColor : 'white',
					color           : '#9ec317',
					boxShadow       : '2px 2px 4px #aaa',
					'&:hover'       : {
						backgroundColor : 'white',
						color           : '#9ec317'
					}
				},
				'@media (min-width: 600px)' : {
					minWidth : 80
				}
			},
			wrapper : {
				fontSize : '0.7rem'
			}
		}
	}
});

const MeetingToolView = ({
	classes,
	style,
	numOfRecievedChats
}) =>
{
	const [ value, setValue ] = useState(0);

	const handleChange = (event, newValue) =>
	{
		setValue(newValue);
	};

	const [ showChatBadge, setShowChatBadge ] = useState(false);

	const isHost = true;

	useEffect(() =>
	{
		// when not showing chat tab
		if (value !== 0)
		{
			setShowChatBadge(true);
		}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ numOfRecievedChats ]);

	return (
		<MuiThemeProvider theme={theme}>
			<Paper square className={classes.root} style={style}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label='icon label tabs'
				>

					<Tab icon={
						<Badge variant='dot' color='secondary' invisible={!showChatBadge}>
							<Icons category={'host'} iconName={'chat'} type={value === 0 ? 'active' : 'normal'} size={'1.5rem'}/>
						</Badge>
					} label='チャット' onClick={() => setShowChatBadge(false)}
					/>

					<Tab icon={<Icons category={'host'} iconName={'memo'} type={value === 1 ? 'active' : 'normal'} size={'1.5rem'}/>} label='メモ' />
				</Tabs>
				<TabPanel value={value} index={0} classes={classes}>
					<Chat isHost={isHost}/>
				</TabPanel>
				<TabPanel value={value} index={1} classes={classes}>
					<div className={classes.memo} >
						<Memo style={style} btnEnabled={[ false, false, false, false, true, false ]}/>
					</div>
				</TabPanel>
			</Paper>
		</MuiThemeProvider>
	);
};

MeetingToolView.propTypes =
{
	classes            : PropTypes.any.isRequired,
	style              : PropTypes.any,
	numOfRecievedChats : PropTypes.number.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		numOfRecievedChats : state.room.numOfRecievedChats
	};
};

const mapDispatchToProps = () =>
{
	return {
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
	}
)(withStyles(styles)(MeetingToolView)));